/**
 * The networks the Report Builder knows how to show.
 *
 * Which of them a client is offered, and every column / filter / breakdown they
 * carry, comes from GET /client-config. This list is the allowlist of keys the UI
 * has artwork for, plus the display name and brand colour used where the API's
 * label is not at hand (AI plan chips, the Excel export title).
 *
 * Adding a network: a `NetworkKey` in `reportBuilder.types.ts`, one entry here,
 * its icon in `components/builderIcons.tsx`, and (optionally) a chip colour in
 * `components/CustomMetricDialog.tsx`.
 */
export const NETWORKS = Object.freeze([
    { key: "meta", label: "Meta", color: "#1877F2" },
    { key: "google_ads", label: "Google Ads", color: "#E8710A" },
    { key: "google_analytics", label: "Google Analytics", color: "#F9AB00" },
    { key: "shopify", label: "Shopify", color: "#5E8E3E" },
    { key: "email", label: "Email", color: "#7C3AED" },
    { key: "awin", label: "Awin", color: "#C2185B" },
    { key: "impact", label: "Impact", color: "#F53541" },
    { key: "avantlink", label: "Avantlink", color: "#0E9384" },
    { key: "cj", label: "CJ", color: "#3E4784" },
    { key: "commission_factory", label: "Commission Factory", color: "#EE46BC" },
    { key: "costingtons", label: "Costingtons", color: "#A15C07" },
    { key: "levanta", label: "Levanta", color: "#039855" },
    { key: "pepperjam", label: "Pepperjam", color: "#EF6820" },
    { key: "rakuten", label: "Rakuten", color: "#B42318" },
]);
/** The affiliate networks: same columns, plus the Publisher breakdown. */
export const AFFILIATE_NETWORK_KEYS = [
    "awin",
    "impact",
    "avantlink",
    "cj",
    "commission_factory",
    "costingtons",
    "levanta",
    "pepperjam",
    "rakuten",
];
const NETWORK_BY_KEY = new Map(NETWORKS.map((network) => [network.key, network]));
export const getNetwork = (key) => NETWORK_BY_KEY.get(key);
